import { Route, Routes } from "react-router";
import ProjectReviewsIndex from "./Index";
import ProjectReviewShow from "./Show";

// Mounted at /project_reviews rather than under /projects: `/projects/:id`
// already owns a child-route tree, and while React Router ranks a static
// segment above a dynamic one, resting the page on that is fragile.
const ProjectReviewsMspa = (): JSX.Element => (
  <Routes>
    <Route path="/" element={<ProjectReviewsIndex />} />
    <Route path="/:id" element={<ProjectReviewShow />} />
  </Routes>
);

export default ProjectReviewsMspa;
